module.exports = __webpack_public_path__ + "static/media/smhs.e6fc4337.jpeg";